import { exactSubstringSearch } from "@lib/helpers/helpers"
import { useRouter } from "next/router"
import { observer } from "mobx-react"
import classNames from "classnames"
import { useStore } from "@features/common"
import { RouterLink } from "@lib/routing"

export const JournalNavigation = observer(function JournalNavigation() {
  const { GlobalModel, BlogModel } = useStore()

  const router = useRouter()

  return (
    <ol className="space-y-5 list-none">
      {BlogModel.categories.map((category, index) => (
        <li
          key={`category-${category.slug}-${index}`}
          data-test-id={`navigation__category_${category.slug}_${index}`}
        >
          <RouterLink
            uri={"/journal/categories/" + category.slug}
            className={classNames(
              "inline-flex font-sans text-2xl tracking-2 uppercase transition-colors duration-100 ease-in hover:text-pink-300",
              {
                "text-pink-300 cursor-default pointer-events-none": exactSubstringSearch(
                  router.asPath.split("?")[0],
                  category.slug,
                ),
              },
            )}
            onClick={GlobalModel.closeMenu}
            data-test-id="navigation__category"
          >
            {category.name}
          </RouterLink>
        </li>
      ))}
    </ol>
  )
})
